import * as $ from 'jquery';
import { ChartBase } from "./ChartBase";
import { groupBy, forEach } from "lodash";

export class MonthlyCreditUsage extends ChartBase {
    protected organizationId: string;
    protected month: string;
    protected year: string;
    private apiUrl: string;

    constructor(private container: JQuery) {
        super(container);
        this.canvasId = "monthly-used-credits-canvas";
        this.organizationId = container.attr('data-organization-id');
        this.year = container.attr('data-year');
        this.month = container.attr('data-month');
        this.apiUrl = container.attr('data-api-url');

        this.configuration = $.extend(true, {}, this.configuration, {
            type: 'line',
            legend: {
                display: false,
                responsive: false
            },
            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            autoSkip: false,
                            callback: function (value, index, values) {
                                return `${value} kr`;
                            }
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            unit: 'week',
                            displayFormats: {
                                week: 'MMM D'
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        title: function (item, data) {
                            let datepart = item[0].label.substring(0, 10)
                            var formatted = new Intl.DateTimeFormat("no").format(new Date(datepart));
                            return `${formatted}`;
                        },
                        label: function (item, data) {
                            return `${item.value} kr`
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        display: false
                    },
                }
            }
        });

        this.initialize();
    }

    private initialize() {
        let that = this;
        this.getMonthlyUsage().then(response => {
            let dates = response.CreditUsage.map(u => u.Date);
            let uniqueDates = [...new Set(dates)]
            let labels = uniqueDates.map(u => u.toString());
            var sets = groupBy(response.CreditUsage, "Service");
            let that = this;
            forEach(sets, function (element, key) {
                let radius = 6;
                if (key === 'Kredittgrense') {
                    radius = 0;
                }
                that.configuration.data.datasets.push({
                    label: key,
                    data: element.map(u => u.Usage),
                    borderColor: element[0].Color,
                    pointRadius: radius
                })
            });

            that.configuration.data.labels = dates;
        }).then(function () {
            that.drawChart();
            that.setZeroPointRadiusForEmptyDates();
        });
    }

    private async getMonthlyUsage(): Promise<MonthlyCreditUsageResponse> {
        return $.ajax({
            type: 'GET',
            url: `${this.apiUrl}?organizationId=${this.organizationId}&year=${this.year}&month=${this.month}`,
            contentType: "application/json",
            success: function (data) {
                return data;
            },
            error: function (data) {
                alert("error");
            }
        });
    }

    private getBorderColor(key): string {
        switch (key) {
            case "InAppTicket":
                return "#3284bf";
            case "SendTicket":
                return '#00AA50';
        }
        return;
    }
}

export class MonthlyCreditUsageResponse {
    public TotalUsage: number;
    public CreditUsage: UsageViewModel[];
    public Dates: Date[];
}

export class UsageViewModel {
    public OrganizationId: string;
    public Service: string;
    public Usage: number;
    public Date: Date;
    public NumberOfPurchases: number;
    public Color: string;
}